/**
 * Individual ticket row component
 */

import React from 'react';
import { DragIndicator } from '@mui/icons-material';
import { Ticket } from '../../types/ticketTypes';
import { getStatusClass, formatStatusDisplay } from '../utils/formatUtils';
import { DragAndDropHandlers } from '../hooks/useDragAndDrop';

export interface TicketRowProps {
  ticket: Ticket;
  isSelected: boolean;
  isDragging: boolean;
  dragOverClass: string;
  onTicketSelect: (ticket: Ticket) => void;
  dragHandlers: DragAndDropHandlers;
}

export const TicketRow: React.FC<TicketRowProps> = ({
  ticket,
  isSelected,
  isDragging,
  dragOverClass,
  onTicketSelect,
  dragHandlers
}) => {
  return (
    <div 
      draggable
      onDragStart={(e) => dragHandlers.handleDragStart(e, ticket)}
      onDragEnd={dragHandlers.handleDragEnd}
      onDragOver={(e) => dragHandlers.handleDragOver(e, ticket)}
      onDragLeave={dragHandlers.handleDragLeave}
      onDrop={(e) => dragHandlers.handleDrop(e, ticket)}
      onClick={() => onTicketSelect(ticket)}
      className={`ticket-row ${isSelected ? 'selected' : ''} ${
        isDragging ? 'dragging' : ''
      } ${dragOverClass}`}
    >
      <div className="ticket-row-content">
        <div className="ticket-id">
          <DragIndicator className="drag-handle" />
          {ticket.id}
        </div>
        
        <div className="ticket-title-column">
          <div 
            className="ticket-title" 
            title={ticket.title}
          >
            {ticket.title}
          </div>
          <div className="ticket-comment">
            <span className="comment-label">COMMENTS:</span>
            <span 
              className="comment-text" 
              title={ticket.lastComment || 'No comments'}
            >
              {ticket.lastComment || 'No comments'}
            </span>
          </div>
        </div>
        
        <div className="ticket-customer-column">
          <div 
            className="customer-info" 
            title={ticket.customer.company || ticket.customer.name}
          >
            {ticket.customer.company || ticket.customer.name}
          </div>
          <div className="ticket-action">
            <span className="action-label">ACTION:</span>
            <span 
              className="action-text" 
              title={ticket.lastAction || 'No actions'}
            >
              {ticket.lastAction || 'No actions'}
            </span>
          </div>
        </div>
        
        <div className="ticket-status">
          <span 
            className={getStatusClass(ticket.status)}
          >
            {formatStatusDisplay(ticket.status)}
          </span>
        </div>
      </div>
    </div>
  );
};